import { Typography, Modal, useMediaQuery, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import EmailIcon from "@mui/icons-material/Email";
import he from "he";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes } from "@fortawesome/pro-solid-svg-icons";
import theme from "../theme/theme";
import HTMLComponents from "../reusable/htmlToReact";
import { Link as RouterLink } from "react-router-dom";

export default function SpecialistCard({ specialist }) {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const specialistContent = specialist.content.rendered;

  let content = false;

  if (specialistContent.length > 0) {
    content = true;
  }

  const style = {
    position: "absolute",
    top: "150px",
    left: "50%",
    transform: "translate(-50%, 0%)",
    bgcolor: "background.paper",
    padding: "50px 40px",
    width: "90%",
    maxHeight: "calc(95vh - 150px)",
    overflow: "scroll",
    outline: "none!important",
    maxWidth: `${theme.width.maxwidth}`,
  };

  return (
    <>
      <Box
        sx={{
          cursor: content ? "pointer" : "default",
        }}
        onClick={handleOpen}
      >
        <img
          src={specialist.acf.profile_picture}
          width="100%"
          style={{
            aspectRatio: 1,
            objectFit: "cover",
          }}
        />
        <Box
          sx={{
            m: "0.5rem 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: "1.2rem",
              fontWeight: 600,
              color: "#0C5EAA",
            }}
          >
            {he.decode(specialist.title.rendered)}
          </Typography>
          <IconButton
            component={RouterLink}
            to="/contact/"
            style={{
              marginLeft: "5px",
              marginTop: "5px",
            }}
          >
            <EmailIcon
              fontSize="small"
              sx={{
                color: "#E9530D",
              }}
            />
          </IconButton>
        </Box>
        <Typography variant="p">{specialist.acf.job_role}</Typography>
        {content && (
          <FontAwesomeIcon
            style={{
              float: "right",
              marginRight: "3px",
              color: "#2a5da5",
              transition: "color 0.3s",
              cursor: "pointer",
            }}
            icon={faPlus}
          />
        )}
      </Box>

      {content && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <FontAwesomeIcon
              icon={faTimes}
              style={{
                position: "absolute",
                top: "20px",
                right: "30px",
                cursor: "pointer",
                fontSize: "2rem",
                color: "#0D60A8",
              }}
              onClick={handleClose}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: "60px",
                marginTop: "30px",
                flexWrap: mobile ? "wrap" : "nowrap",
              }}
            >
              <Box
                sx={{
                  width: mobile ? "100%" : "63%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                  }}
                >
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{
                      fontSize: "1.8rem",
                      fontWeight: 800,
                      color: "#0D60A8",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: specialist.title.rendered,
                    }}
                  />
                  <IconButton
                    component={RouterLink}
                    to="/contact/"
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <EmailIcon
                      fontSize="small"
                      sx={{
                        color: "#E9530D",
                      }}
                    />
                  </IconButton>
                </Box>
                <Typography
                  variant="p"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1.2rem",
                    color: "#E9530D",
                  }}
                >
                  {specialist.acf.job_role}
                </Typography>
                <Box
                  dangerouslySetInnerHTML={{
                    __html: specialist.content.rendered,
                  }}
                />
                {/* <HTMLComponents htmlComponents={specialist.content.rendered} /> */}
              </Box>
              <img
                src={specialist.acf.profile_picture}
                alt={specialist.title.rendered}
                style={{
                  width: mobile ? "100%" : "32%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>
        </Modal>
      )}
    </>
  );
}
